import React, { InputHTMLAttributes, useCallback } from 'react'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  title: string
  active: boolean
  notClick?: boolean
  index: number
  setSelectedTab: (index: number) => void
}

const TabTitle: React.FC<Props> = ({
  title,
  setSelectedTab,
  index,
  active,
  notClick
}) => {
  const onClick = useCallback(() => {
    setSelectedTab(index)
  }, [setSelectedTab, index])

  return (
    <li className="nav-item mt-2">
      <a
        onClick={!notClick && onClick}
        className={`nav-link text-active-primary ms-0 me-10 py-5 ${
          active && 'active'
        }`}
        style={{ cursor: 'pointer', pointerEvents: notClick ? 'none' : 'all' }}
      >
        {title}
      </a>
    </li>
  )
}

export default TabTitle
